import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { Button, Form, Input, Pagination } from 'antd'
import { SearchInput } from 'components/SearchInput'
import { algoliaClient, INDIXES, useSearchIndex } from 'utils/algolia'
import { List } from 'antd'
import { get, map } from 'lodash'
import { PlaySquareOutlined } from '@ant-design/icons'
import './styles.scss'
import { animated, useSpring } from 'react-spring'
import { SearchBook } from 'components/SearchBook'
import { SearchProvider } from 'components/SearchBook/context'

const Item = ({ onClick, ...hit }) => {
  const { artist_name, name, album_name, id } = hit

  return (
    <List.Item onClick={onClick} key={id}>
      <List.Item.Meta
        title={`${name} by ${artist_name}`}
        description={`Album: ${album_name}`}
      />
      <Button type="link" icon={<PlaySquareOutlined />} />
    </List.Item>
  )
}
export const ListItems = ({
  onSelect,
  results,
  nbPages,
  page,
  onPageChange,
}) => {
  const data = useMemo(
    () =>
      map(results, (hit) => ({
        ...hit,
        onClick: () => {
          onSelect(hit)
          console.log(hit)
        },
      })),
    [results]
  )

  return (
    <>
      <List dataSource={data} renderItem={Item} size="small" bordered />
      <Pagination
        size="small"
        className="Results-Pagin"
        current={page}
        total={nbPages}
        onChange={onPageChange}
        showSizeChanger={false}
      />
    </>
  )
}

export const FormSearchSong = ({ onFinish }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [props, set] = useSpring(() => ({
    height: '0px',
    overflow: 'hidden',
    config: { duration: 90 },
  }))

  const handleItemSelect = useCallback(({ file_url: url, ...data }) => {
    onFinish({ url, ...data })
  }, [])
  const toggleResults = useCallback((event) => {
    setModalOpen(true)
    event.target.blur()
  }, [])

  return (
    <>
      <SearchProvider>
        <SearchInput onClick={toggleResults} />
        <SearchBook
          visible={modalOpen}
          handleClose={() => setModalOpen(false)}
          onSelect={handleItemSelect}
        />
      </SearchProvider>
    </>
  )
}
